<script setup lang="ts">
/**
 * UI-kit component
 * Category: Typography
 * Name: 'Headers/H4'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=216-126906&m=dev'
*/

defineOptions({
  name: 'HeadingH4',
})
</script>

<template>
  <h4 class="heading-h4">
    <slot />
  </h4>
</template>

<style scoped lang="scss" src="@scss/components/UI/Typography/HeadingH4.scss" />
